module.exports = __webpack_public_path__ + "static/media/wcolor_bg_06.8ddc84db.png";